const
    form = document.querySelector('.form-recaptcha'),
    formAction = document.querySelector('#form-values').dataset.formAction

form.addEventListener('submit', function (e) {
  e.preventDefault()

  // Récupère un token auprès de Google, le met dans un input à la fin du form et soumet celui-ci
  grecaptcha.ready(function () {
    grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: formAction}).then(function (token) {
      let input = document.querySelector('[data-recaptcha-token]')
      input.value = token
      form.submit()
    })
  })
})